import type { OnInit } from '@angular/core'
import { Component, inject } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'

import { firstValueFrom } from 'rxjs'

import { ArticlesService } from '../../../api/articles-service/articles.service'

@Component({
  selector: 'dhp-old-article',
  template: ` <p>Redirecting...</p> `,
})
export class OldArticleComponent implements OnInit {
  articlesService = inject(ArticlesService)
  route = inject(ActivatedRoute)
  router = inject(Router)

  ngOnInit(): void {
    const id = parseInt(this.route.snapshot.paramMap.get('id') ?? '', 10)

    if (!isNaN(id) && id > 0) {
      firstValueFrom(this.articlesService.getArticleIdByOldId(id)).then(
        articleId => {
          // Redirect to the new route with query parameters
          this.router.navigate(['/articles', articleId], {
            queryParams: { banner: 'oldsite' },
          })
        }
      )
    }
  }
}
